import React from 'react';
import { Typography, TextField, Button } from '@material-ui/core';
import copy from 'copy-to-clipboard';
import FileCopyIcon from '@material-ui/icons/FileCopy';

import UserPresenter from 'presenters/UserPresenter';
import RealEstateAgentPresenter from 'presenters/RealEstateAgentPresenter';
import { useTranslation } from 'react-i18next';
import useStyles from './useStyles';

const MyCustomLinkForm = props => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { currentUser } = props;

  const handleCopyReferralLinkToClipboard = () => {
    copy(RealEstateAgentPresenter.referralLink(currentUser));
  };

  return (
    <div className={classes.container}>
      <Typography variant="body1" className={classes.title}>
        {t('components.RealEstateAgentDashboard.MyCustomLinkForm.header')}
      </Typography>
      <div className={classes.referralLink}>
        <TextField
          fullWidth
          id="referralLink"
          variant="outlined"
          className={classes.field}
          color="secondary"
          name="referralLink"
          value={RealEstateAgentPresenter.referralLink(currentUser)}
          FormHelperTextProps={{
            style: {
              marginLeft: 0,
            },
          }}
          InputLabelProps={{
            shrink: false,
          }}
        />
        <Button startIcon={<FileCopyIcon />} className={classes.button} onClick={handleCopyReferralLinkToClipboard}>
          {t('components.RealEstateAgentDashboard.MyCustomLinkForm.copy')}
        </Button>
      </div>
    </div>
  );
};

MyCustomLinkForm.propTypes = {
  currentUser: UserPresenter.shape().isRequired,
};

export default MyCustomLinkForm;



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentDashboard/components/MyCustomLinkForm/MyCustomLinkForm.js